// Copyright (c) 2026 Finerty Data Ltd. All rights reserved.
//
// This file is part of proprietary software owned by Finerty Data Ltd.
// It is confidential and may not be copied, distributed, modified, or used,
// in whole or in part, without the prior written consent of Finerty Data Ltd.
//
// Author: Ahmed Hosny

import type { Icon } from 'iconsax-react';

const CloseIcon: Icon = ({ size = 24, color, variant: _variant, className, style, ...rest }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
    style={style}
    {...rest}
  >
    <line x1="4" y1="19.9393" x2="19.9393" y2="4" stroke={color || 'currentColor'} strokeWidth="1.5" strokeLinecap="round" />
    <line x1="4.06066" y1="4" x2="20" y2="19.9393" stroke={color || 'currentColor'} strokeWidth="1.5" strokeLinecap="round" />
  </svg>
);

export { CloseIcon };
